<script setup>
import { computed, inject } from 'vue'
import { useRouter } from 'vue-router'
import { useGlobalStore } from '@/store/global.js'

// The site footer is now the shared <ns-footer> web component (@nashsever/chrome).
// Columns mirror the previous layout: three stacks, the first two grouping
// several sections vertically.
const global = useGlobalStore()
const router = useRouter()
const theme = inject('theme')

const columns = computed(() => {
  const menu = global.resources?.menu ?? {}
  const services = {
    title: 'Сервисы',
    children: (global.resources?.services ?? []).map(s => ({
      title: s.title,
      link: s.link,
      external: true,
    })),
  }
  const contacts = {
    title: 'Контакты',
    children: [{ title: 'support@nashsever51.ru', link: 'mailto:support@nashsever51.ru', external: true }],
  }
  // Visual column order matches the live site: [materials, activities] ·
  // [services] · [projects, contacts, contests].
  return [
    [menu.materials, menu.activities].filter(Boolean),
    [services],
    [menu.projects, contacts, menu.contests].filter(Boolean),
  ]
})

const columnsAttr = computed(() => JSON.stringify(columns.value))

function onNavigate(e) {
  const d = e.detail
  const p = Array.isArray(d) ? d[0] : d
  if (p?.link) {
    router.push(p.link)
  }
}
</script>

<template>
  <ns-footer home="/" :columns="columnsAttr" :theme="theme" @navigate="onNavigate" />
</template>
